import { Box, DialogContent, Divider } from "@mui/material";
import StageDialog from "../StageDialog";
import { MeetingDialogTitle } from "../widgets";
import { ClientSettingsProvider, MediaDevicesContext, MediaDevicesHandler } from "@dvrt/web-phone-client";
import VideoPreview from "./VideoPreview";
import Footer from "./Footer";
import DisplayNameSetting from "./DisplayNameSetting";
import { phoneClientLocalStorage } from "conference/tools";

const PreparationDialog = () => {
    const mediaDevicesHandler = new MediaDevicesHandler();

    return (
        <MediaDevicesContext.Provider value={mediaDevicesHandler}>
            <ClientSettingsProvider settings={phoneClientLocalStorage}>
                <StageDialog>
                    <>
                        <MeetingDialogTitle />
                        <Box sx={{ padding: "0.5em 1em" }}>
                            <DisplayNameSetting />
                        </Box>
                        <Divider />
                        <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
                            <VideoPreview />
                        </DialogContent>
                        <Divider />
                        <Footer />
                    </>
                </StageDialog>
            </ClientSettingsProvider>
        </MediaDevicesContext.Provider>
    );
};

export default PreparationDialog;
